<template>
  <v-layout
    align-center
    justify-center
    :style="{
      backgroundColor: '#13abb1'
    }"
  >
    <!-- Used for showing tick animations -->
    <v-flex
      xs11
      sm7
      md6
      lg6
      d-flex
      v-if="animationPath"
    >
      <v-card class="card-content" :height="$vuetify.breakpoint.xsOnly ? 296 : 480" :width="$vuetify.breakpoint.xsOnly ? 328 :720">
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            class="animation"
          >
            <v-card flat>
              <v-card-text class="pa-0">
                <div class="bounding-box" v-if="animationWidth && animationHeight">
                  <lottie-animation
                    :loop="lottieOptions.loop"
                    :autoplay="lottieOptions.autoplay"
                    :height="animationHeight"
                    :width="animationWidth"
                    :path="animationPath"
                  />
                </div>
                <v-flex
                  d-flex
                  class="animation-title"
                  :style="{'width':`${animationWidth}px`}"
                >
                  <v-layout
                    row
                  >
                    <v-flex class="label" :class="{'animation-title-xs-only':$vuetify.breakpoint.xsOnly}" xs4>
                      <span align="center">{{ $t('message.bizgainOnboarding.businessDetails') }}</span>
                    </v-flex>
                    <v-flex class="label" :class="{'animation-title-xs-only':$vuetify.breakpoint.xsOnly}" xs4>
                      <span align="center">{{ $t('message.bizgainOnboarding.creative') }}</span>
                    </v-flex>
                    <v-flex class="label" :class="{'animation-title-xs-only':$vuetify.breakpoint.xsOnly}" xs4>
                      <span align="center">{{ $t('message.bizgainOnboarding.launching') }}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            :class="{'mt-5':$vuetify.breakpoint.smAndUp,'mt-4':$vuetify.breakpoint.xsOnly}"
          >
            <router-view />
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <!-- Used for popup layout -->
    <v-flex
      xs11
      sm7
      md6
      lg6
      d-flex
      v-else
    >
      <router-view />
    </v-flex>
  </v-layout>
</template>
<script>
import {
  VFlex,
  VCard,
  VCardText,
  VLayout
} from 'vuetify/lib';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
export default {
  components: {
    VFlex,
    VCard,
    VCardText,
    VLayout,
    LottieAnimation
  },
  props: {
    animationPath: {
      type: String,
      default: null
    }
  },
  computed: {
    animationWidth(){
      let animationWidth;
      switch(this.$vuetify.breakpoint.name){
        case 'xs': animationWidth = 290
          break;
        case 'sm': animationWidth = 380
          break;
        case 'md': animationWidth = 431
          break;
        case 'lg':
        case 'xl': animationWidth = 583
          break;
      }
      return animationWidth;
    },
    animationHeight(){
      let animationHeight;
      switch(this.$vuetify.breakpoint.name){
        case 'xs': animationHeight = 230
          break;
        case 'sm': animationHeight = 250
          break;
        case 'md': animationHeight = 270
          break;
        case 'lg':
        case 'xl': animationHeight = 310
          break;
      }
      return animationHeight;
    }
  },
  data(){
    return{
      lottieOptions: {
        loop: false,
        autoplay: false
      }
    }
  }
}
</script>
<style lang="scss" scoped>

  .card-content{
    border-radius: 0.5rem;
  }

  .animation-title{
    margin: 0px auto;
  }

  .label {
    padding: 0px !important;
  }

  @media (max-width: 599px) {
    .bounding-box {
      width: 96px;
      height: 96px;
      position: relative;
      top: -57px;
      right: 97px;
      margin: 0px auto;
    }
  }

  @media (min-width: 600px) and (max-width: 959px) {
      .bounding-box {
        margin: 0px auto;
        height: 176px;
      }
  }

  @media (min-width: 960px) and (max-width: 1179px) {
      .bounding-box {
        margin: 0px auto;
        height: 195px;
      }
  }

   @media (min-width: 1180px) {
      .bounding-box {
        margin: 0px auto;
        height: 225px;
      }
  }
.animation-title-xs-only {
    font-size: 12px !important;
}
</style>